import CloseIcon from "@mui/icons-material/Close"
import Alert from "@mui/material/Alert"
import IconButton from "@mui/material/IconButton"
import Snackbar from "@mui/material/Snackbar"
import { useCallback, useState } from "react"

export default function CloseableSnackbar({
  open,
  onClose,
  message,
  severity = "success",
}) {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={severity === "error" ? 8000 : 5000}
      action={
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      }
      anchorOrigin={{
        horizontal: "right",
        vertical: "bottom",
      }}
    >
      <Alert onClose={onClose} variant="filled" severity={severity}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export function useCloseableSnackbarState() {
  const [isOpen, setIsOpen] = useState(false)
  const [message, setMessage] = useState("")
  const [severity, setSeverity] = useState("success")

  const open = useCallback((nextMessage, nextSeverity = "success") => {
    setMessage(nextMessage)
    setSeverity(nextSeverity)
    setIsOpen(true)
  }, [])

  const openError = useCallback((nextMessage) => {
    setMessage(nextMessage)
    setSeverity("error")
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
    setMessage("")
    setSeverity("success")
  }, [])

  return {
    isOpen,
    message,
    severity,
    open,
    openError,
    close,
  }
}
